import Button from '@mui/material/Button';
import { Edit } from '@mui/icons-material';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import openV2Editor from '../../../helpers/openV2Editor';

// The one entry into the v2 site editor: mints a single-use entry code
// server-side (120s TTL) and jumps straight in — billing-portal pattern.
// `journal` renders the expedition-journal pill instead of the MUI button
// for the new-design surfaces.
export default function OpenV2EditorButton({
  blogId,
  size = 'medium',
  className = '',
  journal = false,
}) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const open = () => {
    setLoading(true);
    openV2Editor(blogId)
      .then(opened => {
        // A refused session (no URL minted) must not look like a dead
        // button — say what happened.
        if (!opened)
          enqueueSnackbar(
            'The editor is not ready for this blog yet — try again in a minute.',
            { variant: 'info' },
          );
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        enqueueSnackbar('Could not open the editor — please try again.', {
          variant: 'error',
        });
        setLoading(false);
      });
  };

  if (journal) {
    return (
      <button
        type="button"
        onClick={open}
        disabled={loading}
        className={`tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border-0 tw-cursor-pointer tw-px-7 tw-py-3 tw-text-base tw-font-semibold tw-bg-primary-600 tw-text-white hover:tw-bg-primary-700 tw-shadow-[0_10px_30px_-10px_rgba(0,137,123,0.7)] tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 disabled:tw-opacity-60 disabled:tw-cursor-wait ${className}`}
      >
        {loading ? 'Opening…' : 'Open editor'}
        <Edit fontSize="small" />
      </button>
    );
  }

  return (
    <Button
      size={size}
      variant="contained"
      color="primary"
      className={className}
      disabled={loading}
      onClick={open}
    >
      {loading ? 'Opening…' : 'Open editor'} <Edit className="ml-2" />
    </Button>
  );
}
